import { registryLabel } from '@/types/stats/registryLabel.ts';

/**
 * `PARTICIPANTS_WITH_OPTIONS` jedzie w metrykach `selections` (liczba),
 * pozostałe dwie — w metrykach `revenue[]`, czyli per waluta.
 */
export enum OptionStatsMetricKey {
  PARTICIPANTS_WITH_OPTIONS = 'PARTICIPANTS_WITH_OPTIONS',
  REVENUE_SHARE = 'REVENUE_SHARE',
  REVENUE_PER_PARTICIPANT = 'REVENUE_PER_PARTICIPANT',
}

export const OPTION_STATS_METRIC_LABELS: Record<OptionStatsMetricKey, string> =
  {
    [OptionStatsMetricKey.PARTICIPANTS_WITH_OPTIONS]:
      'Uczestnicy z opcją dodatkową',
    [OptionStatsMetricKey.REVENUE_SHARE]: 'Udział w przychodzie',
    [OptionStatsMetricKey.REVENUE_PER_PARTICIPANT]: 'Średnio na uczestnika',
  };

export const optionStatsMetricLabel = (key: string): string =>
  registryLabel(OPTION_STATS_METRIC_LABELS, key, 'metryka sprzedaży opcji');
